import React, { useEffect, useState, useContext } from 'react';
import './GeneralFileList.css';
import FileButton from '../FileButton';
import { AuthContext } from '../../authContext';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';


function GeneralFileList({ documentList, updateDocumentList, className, uploadingFiles = [], insideCategoryDatabase = false}) {
    const {accessToken} = useContext(AuthContext);
    const { t: tCommon } = useTranslation('common');
    const [isExpanded, setIsExpanded] = useState(false); // Estado para controle de expansão

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const deleteDocument = (doc) => {
        // ✅ Caso esteja dentro do CategoryDatabase, não faz requisição
        if (insideCategoryDatabase) {
            updateDocumentList(doc, "remove");
            return;
        }
        // Remove da lista assim que clicar no X
        updateDocumentList(doc, "remove");
    
        fetch(`${process.env.REACT_APP_API_URL}/delete_documents_selfassistant`, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({'docs': doc}),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`Erro ao deletar: ${response.status} ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
        })
        .catch((error) => {
            console.error('Erro ao deletar documento:', error);
            // Readiciona em caso de erro
            updateDocumentList(doc);
        });
    };
    

    return (
        (documentList.length > 0 || uploadingFiles.length > 0) && ( // Renderiza apenas se houver documentos
            <div className={`assistant-file-list-container ${className || ''}`}>
                <div className="assistant-file-list">
                    {uploadingFiles.map((file, index) => (
                        <div className='assistant-file-item' key={`uploading-${index}`}>
                            <div className="loading-icon-wrapper">
                                <CircularProgress size={13} />
                            </div>
                            <div className="assistant-file-name">{file.filename}</div>
                        </div>
                    ))}

                    {documentList.slice(0, isExpanded ? documentList.length : 5).map((doc, index) => ( 
                        
                        <FileButton
                        key={index}
                        filename={doc.filename}
                        onDelete={() => deleteDocument(doc)}
                        />
                    ))}
                </div>
    
                {(documentList.length + uploadingFiles.length) > 5 && (
                    <div className={`file-list-fade ${isExpanded ? 'expanded' : ''}`} onClick={toggleExpand}>
                        <div className={`file-list-arrow ${isExpanded ? 'expanded' : ''}`}></div>
                    </div>
                )}
            </div>
        )
    );
}

export default GeneralFileList;
